"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PreferredConsultant_1 = require("./PreferredConsultant");
var PreferredConsultantWrapper = function (_a) {
    var name = _a.name;
    return <>{name && <PreferredConsultant_1.default name={name}/>}</>;
};
exports.default = PreferredConsultantWrapper;
